<style>
  .subMenuViewAll {
    position: relative;
    display: block;
    float: right;
  }
</style>

<div class="modal-header">
  <h4 class="modal-title">
    <i class="fa fa-plus-circle mr-2"></i>Add Role
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" style="overflow-y: auto;">
  <form [formGroup]="addRoleForm" novalidate>

    <div class="form-group">

      <!-- RoleName Text Input -->
      <div class="row">
        <div class="col-md-10">
          <input type="text" class="col-md-12 form-control rolename-textbox" formControlName="roleName"
            placeholder="Role Name" />
        </div>
        <div class="col-md-2 md-2">
          <button type="button" class="btn btn-primary btn-sm col-md-12"
            (click)="viewAll();$event.stopPropagation();">View
            All</button>
        </div>
      </div>
      <div class="search-bar">
        <input name="search" type="search" placeholder="Search">
        <button class="search-icon" type="submit"><img alt="search-icon" src="/assets/images/search-icon.png"></button>

      </div>
      <div class="row"
        *ngIf="addRoleForm.controls['roleName'].hasError('required') && addRoleForm.controls['roleName'].touched">
        <div class="col-md-12 text-danger">
          <i class="fa fa-exclamation-circle mr-1"></i>Please enter role name
        </div>
      </div>
      <div class="row"
        *ngIf="addRoleForm.controls['roleName'].hasError('pattern') && addRoleForm.controls['roleName'].touched">
        <div class="col-md-12 text-danger">
          <i class="fa fa-exclamation-circle mr-1"></i>Special Characters and Numbers are not allowed
        </div>
      </div>
      <div class="row" *ngIf="addRoleForm.controls['roleName'].hasError('maxlength') ">
        <div class="col-md-12 text-danger">
          <i class="fa fa-exclamation-circle mr-1"></i>Please enter Rolename not exceeding 50 characters
        </div>
      </div>

      <div class="clearfix" style="margin-top:10px">
      </div>


      <div class="add-role-row">
        <!-- DO Not ALter ANy Dom Structure -->
        <!-- master Menu -->
        <div class="row">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown #myDrop="ngbDropdown" [autoClose]="'outside'" id="masterMenu">

            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle
              (click)="LeftMenuClick('Master'); $event.stopPropagation()"
              data-toggle="dropdown" aria-expanded="false">
              Master
            </a>

            <!-- [ngStyle] = "{'display' : menuName == 'Master' ? 'block' : 'none'}" -->

            <div ngbDropdownMenu placement="bottom-right" aria-labelledby="" id="masterSubMenu"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              (click)="Submenu($event)"
              (mousedown)="$event.stopPropagation()"
              role="menu" style="padding: 0; min-width: 600px;">
              
              <!-- Select All Header -->
              <div style="padding: 1rem 1.25rem; background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" class="inputCheckbox" id="masterCheckbox"
                    (click)="ParentMenuCheckboxClicked('masterCheckbox','masterSubMenu', masterMenu)">
                  <span style="font-weight: 600; font-size: 0.95rem; color: #495057;">Select All</span>
                </div>
              </div>

              <!-- Permissions Table -->
              <div style="max-height: 400px; overflow-y: auto;">
                <table class="permissions-table">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Permission Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let menu of masterMenu" id="{{menu._id}}"
                      (mouseenter)="mouseoverDisplay(menu,$event,'Master',menu.MenuDisplayName)"
                      (mouseleave)="mouseleaveDisplay(menu,$event,'Master',menu.MenuDisplayName)">
                      <td>
                        <input type="checkbox" class="inputCheckbox" id="{{menu.MenuDisplayName}}"
                          (click)="checkboxClicked(menu,$event,menu.MenuDisplayName,'masterCheckbox',masterMenu)">
                      </td>
                      <td>
                        <span class="permission-name">{{menu.MenuDisplayName}}</span>
                      </td>
                      <td>
                        <div class="permission-icons-container" (mousedown)="$event.stopPropagation()">
                          <i class="rolemaster-icons rolemaster-icon-display fa"
                            [ngClass]="{'fa-eye' : child.IconName == 'view','fa-pencil' : child.IconName == 'edit','fa-plus-circle' : child.IconName == 'add','fa-trash-o' : child.IconName == 'delete' , 'fa-shield' : child.IconName == 'authorize' , 'fa-plus-square-o' : child.IconName == 'create' , 'fa-download' : child.IconName == 'download', 'fa-database' : child.IconName == 'database-backup' ,'fa-check-square-o' : child.IconName == 'review' , 'fa-caret-square-o-right' : child.IconName == 'execute', 'fa-file' : child.IconName == 'summaryReport','fa-file-pdf-o' : child.IconName == 'individualReport'}"
                            [class.icon-selected]="isIconSelected(child.Url)"
                            [class.icon-unselected]="!isIconSelected(child.Url)"
                            *ngFor="let child of menu.ChildResources" 
                            title="{{child.IconName}}" 
                            id="{{child.Url}}"
                            (mousedown)="$event.stopPropagation(); $event.preventDefault();"
                            (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view',menu.MenuDisplayName , child ,'masterCheckbox',masterMenu)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Board Evaluation Menu -->
    
        <div class="row" *ngIf="(isBoardEvaluationConfig)">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown [autoClose]="'outside'" id="boardEvaluationMenu">
            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle
              (click)="LeftMenuClick('boardEvaluationMenu'); $event.stopPropagation()" data-toggle="dropdown" aria-expanded="false">Board
              Evaluation</a>

            <div ngbDropdownMenu placement="bottom-right"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              id="boardEvaluationSubMenu" aria-labelledby="" 
              (click)="Submenu($event)"
              (mousedown)="$event.stopPropagation()"
              role="menu" style="padding: 0; min-width: 600px;">

              <!-- Select All Header -->
              <div style="padding: 1rem 1.25rem; background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" class="inputCheckbox" id="boardEvaluationCheckbox"
                    (click)="ParentMenuCheckboxClicked('boardEvaluationCheckbox','boardEvaluationSubMenu', boardEvaluationMenu, 'board-')">
                  <span style="font-weight: 600; font-size: 0.95rem; color: #495057;">Select All</span>
                </div>
              </div>

              <!-- Permissions Table -->
              <div style="max-height: 400px; overflow-y: auto;">
                <table class="permissions-table">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Permission Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let menu of boardEvaluationMenu" id="{{menu._id}}"
                      (mouseenter)="mouseoverDisplay(menu,$event,'BoardEvaluation','board-' + menu.MenuDisplayName)"
                      (mouseleave)="mouseleaveDisplay(menu,$event,'BoardEvaluation','board-' + menu.MenuDisplayName)">
                      <td>
                        <input type="checkbox" class="inputCheckbox" id="board-{{menu.MenuDisplayName}}"
                          (click)="checkboxClicked(menu,$event,'board-' + menu.MenuDisplayName,'boardEvaluationCheckbox',boardEvaluationMenu)">
                      </td>
                      <td>
                        <span class="permission-name">{{menu.MenuDisplayName}}</span>
                      </td>
                      <td>
                        <div class="permission-icons-container" (mousedown)="$event.stopPropagation()">
                          <i class="rolemaster-icons rolemaster-icon-display fa"
                            [ngClass]="{'fa-eye' : child.IconName == 'view','fa-pencil' : child.IconName == 'edit','fa-plus-circle' : child.IconName == 'add','fa-trash-o' : child.IconName == 'delete' , 'fa-shield' : child.IconName == 'authorize' , 'fa-plus-square-o' : child.IconName == 'create', 'fa-download' : child.IconName == 'download', 'fa-database' : child.IconName == 'database-backup','fa-check-square-o' : child.IconName == 'review' , 'fa-caret-square-o-right' : child.IconName == 'execute', 'fa-file' : child.IconName == 'summaryReport','fa-file-pdf-o' : child.IconName == 'individualReport'}"
                            [class.icon-selected]="isIconSelected(child.Url)"
                            [class.icon-unselected]="!isIconSelected(child.Url)"
                            *ngFor="let child of menu.ChildResources" 
                            title="{{child.IconName}}" 
                            id="{{child.Url}}"
                            (mousedown)="$event.stopPropagation(); $event.preventDefault();"
                            (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view','board-' + menu.MenuDisplayName , child,'boardEvaluationCheckbox',boardEvaluationMenu)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        
          <!-- Risk Evaluation Menu -->
        <div class="row" *ngIf="(isRiskEvaluationConfig)">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown [autoClose]="'outside'" id="riskEvaluationMenu">
            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle
              (click)="LeftMenuClick('riskEvaluationMenu'); $event.stopPropagation()" data-toggle="dropdown" aria-expanded="false">Risk
              Evaluation</a>

            <div ngbDropdownMenu placement="bottom-right"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              id="riskEvaluationSubMenu" aria-labelledby="" 
              (click)="Submenu($event)"
              (mousedown)="$event.stopPropagation()"
              role="menu" style="padding: 0; min-width: 600px;">

              <!-- Select All Header -->
              <div style="padding: 1rem 1.25rem; background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" class="inputCheckbox" id="riskEvaluationCheckbox"
                    (click)="ParentMenuCheckboxClicked('riskEvaluationCheckbox','riskEvaluationSubMenu', riskEvaluationMenu, 'risk-')">
                  <span style="font-weight: 600; font-size: 0.95rem; color: #495057;">Select All</span>
                </div>
              </div>

              <!-- Permissions Table -->
              <div style="max-height: 400px; overflow-y: auto;">
                <table class="permissions-table">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Permission Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let menu of riskEvaluationMenu" id="{{menu._id}}"
                      (mouseenter)="mouseoverDisplay(menu,$event,'RiskEvaluation','risk-' + menu.MenuDisplayName)"
                      (mouseleave)="mouseleaveDisplay(menu,$event,'RiskEvaluation','risk-' + menu.MenuDisplayName)">
                      <td>
                        <input type="checkbox" class="inputCheckbox" id="risk-{{menu.MenuDisplayName}}"
                          (click)="checkboxClicked(menu,$event,'risk-' + menu.MenuDisplayName,'riskEvaluationCheckbox',riskEvaluationMenu)">
                      </td>
                      <td>
                        <span class="permission-name">{{menu.MenuDisplayName}}</span>
                      </td>
                      <td>
                        <div class="permission-icons-container" (mousedown)="$event.stopPropagation()">
                          <i class="rolemaster-icons rolemaster-icon-display fa"
                            [ngClass]="{'fa-eye' : child.IconName == 'view','fa-pencil' : child.IconName == 'edit','fa-plus-circle' : child.IconName == 'add','fa-trash-o' : child.IconName == 'delete' , 'fa-shield' : child.IconName == 'authorize' , 'fa-plus-square-o' : child.IconName == 'create', 'fa-download' : child.IconName == 'download', 'fa-database' : child.IconName == 'database-backup','fa-check-square-o' : child.IconName == 'review' , 'fa-caret-square-o-right' : child.IconName == 'execute', 'fa-file' : child.IconName == 'summaryReport','fa-file-pdf-o' : child.IconName == 'individualReport'}"
                            [class.icon-selected]="isIconSelected(child.Url)"
                            [class.icon-unselected]="!isIconSelected(child.Url)"
                            *ngFor="let child of menu.ChildResources" 
                            title="{{child.IconName}}" 
                            id="{{child.Url}}"
                            (mousedown)="$event.stopPropagation(); $event.preventDefault();"
                            (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view','risk-' + menu.MenuDisplayName , child,'riskEvaluationCheckbox',riskEvaluationMenu)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- DO Not ALter ANy Dom Structure -->
        <!-- GOvernance Menu -->
        <!-- <div class="row" *ngIf="(isGovevaConfig && isGovernance)">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown [autoClose]="'outside'" id="governanceMenu">

            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle (click)="LeftMenuClick('governanceMenu'); $event.stopPropagation()" data-toggle="dropdown"
              aria-expanded="false">Governance</a>

            <div ngbDropdownMenu placement="bottom-right"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              id="governanceSubMenu" aria-labelledby="" 
              (click)="Submenu($event)"
              (mousedown)="$event.stopPropagation()"
              role="menu">

              <div class="dropdown-item">
                <div class="drop">
                  <input type="checkbox" class="pull-left" 
                    id="governanceCheckbox"
                    (click)="ParentMenuCheckboxClicked('governanceCheckbox','governanceSubMenu', governanceMenu)">
                  <span>Select All</span>
                </div>
              </div>

              <a href="javascript: void(0);" class="dropdown-item" 
                *ngFor="let menu of governanceMenu" (mouseenter)="mouseoverDisplay(menu,$event, 'Governance')"
                (click)="Submenu($event)" (mouseleave)="mouseleaveDisplay(menu,$event,'Governance')">
                <div class="drop">
                  <input type="checkbox" class="pull-left inputCheckbox" id="{{menu.MenuDisplayName}}"
                    (click)="checkboxClicked(menu,$event,menu.MenuDisplayName,'governanceCheckbox',governanceMenu)">

                  <span style="float:right;display:inline-flex;gap:8px;align-items:center;">
                    <i class="rolemaster-icons rolemaster-icon-display icon-unselected fa"
                      [ngClass]="{'fa-eye' : child.IconName == 'view','fa-pencil' : child.IconName == 'edit','fa-plus-circle' : child.IconName == 'add','fa-trash-o' : child.IconName == 'delete', 'fa-shield' : child.IconName == 'authorize' , 'fa-plus-square-o' : child.IconName == 'create', 'fa-download' : child.IconName == 'download', 'fa-database' : child.IconName == 'database-backup','fa-check-square-o' : child.IconName == 'review' , 'fa-caret-square-o-right' : child.IconName == 'execute', 'fa-file' : child.IconName == 'summaryReport','fa-file-pdf-o' : child.IconName == 'individualReport'}"
                      [class.icon-selected]="isIconSelected(child.Url)"
                      [class.icon-unselected]="!isIconSelected(child.Url)"
                      *ngFor="let child of menu.ChildResources" title="{{child.IconName}}" id="{{child.Url}}"
                      style="font-size:16px;padding:4px;"
                      (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view',menu.MenuDisplayName , child,'governanceCheckbox',governanceMenu)"></i>
                  </span>
                  {{menu.MenuDisplayName}}
                </div>
              </a>
            </div>
          </div>
        </div> -->

        <!-- DO Not ALter ANy Dom Structure -->
        <!-- Compliance Menu -->
        <div class="row" *ngIf="(isPSSConfig  || isAllConfig)">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown [autoClose]="'outside'" id="complianceMenu">
            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle (click)="LeftMenuClick('complianceMenu'); $event.stopPropagation()"
              data-toggle="dropdown" aria-expanded="false">Compliance</a>

            <div ngbDropdownMenu placement="bottom-right"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              id="complianceSubMenu" aria-labelledby="" 
              (click)="Submenu($event)"
              (mousedown)="$event.stopPropagation()"
              role="menu" style="padding: 0; min-width: 600px;">

              <!-- Select All Header -->
              <div style="padding: 1rem 1.25rem; background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" class="inputCheckbox" id="complianceCheckbox"
                    (click)="ParentMenuCheckboxClicked('complianceCheckbox','complianceSubMenu', complianceMenu)">
                  <span style="font-weight: 600; font-size: 0.95rem; color: #495057;">Select All</span>
                </div>
              </div>

              <!-- Permissions Table -->
              <div style="max-height: 400px; overflow-y: auto;">
                <table class="permissions-table">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Permission Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let menu of complianceMenu" id="{{menu._id}}"
                      (mouseenter)="mouseoverDisplay(menu,$event,'Compliance')"
                      (mouseleave)="mouseleaveDisplay(menu,$event,'Compliance')">
                      <td>
                        <input type="checkbox" class="inputCheckbox" id="{{menu.MenuDisplayName}}"
                          (click)="checkboxClicked(menu,$event,menu.MenuDisplayName,'complianceCheckbox',complianceMenu)">
                      </td>
                      <td>
                        <span class="permission-name">{{menu.MenuDisplayName}}</span>
                      </td>
                      <td>
                        <div class="permission-icons-container" (mousedown)="$event.stopPropagation()">
                          <i class="rolemaster-icons rolemaster-icon-display fa"
                            [ngClass]="{'fa-eye' : child.IconName == 'view','fa-pencil' : child.IconName == 'edit','fa-plus-circle' : child.IconName == 'add','fa-trash-o' : child.IconName == 'delete' , 'fa-shield' : child.IconName == 'authorize' , 'fa-plus-square-o' : child.IconName == 'create', 'fa-download' : child.IconName == 'download', 'fa-database' : child.IconName == 'database-backup','fa-check-square-o' : child.IconName == 'review' , 'fa-caret-square-o-right' : child.IconName == 'execute', 'fa-file' : child.IconName == 'summaryReport','fa-file-pdf-o' : child.IconName == 'individualReport'}"
                            [class.icon-selected]="isIconSelected(child.Url)"
                            [class.icon-unselected]="!isIconSelected(child.Url)"
                            *ngFor="let child of menu.ChildResources" 
                            title="{{child.IconName}}" 
                            id="{{child.Url}}"
                            (mousedown)="$event.stopPropagation(); $event.preventDefault();"
                            (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view',menu.MenuDisplayName , child,'complianceCheckbox',complianceMenu)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- DO Not ALter ANy Dom Structure -->
        <!-- UPSI Menu -->
        <div class="row" *ngIf="(isUPSIConfig)">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown #myDrop="ngbDropdown" [autoClose]="'outside'" id="upsiMenu">

            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle (click)="LeftMenuClick('upsiMenu'); $event.stopPropagation()"
              data-toggle="dropdown" aria-expanded="false">

              UPSI
            </a>

            <div ngbDropdownMenu placement="bottom-right" aria-labelledby="" id="upsiSubMenu"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              (click)="Submenu($event)" 
              (mousedown)="$event.stopPropagation()"
              role="menu" style="padding: 0; min-width: 600px;">

              <!-- Select All Header -->
              <div style="padding: 1rem 1.25rem; background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" class="inputCheckbox" id="upsiCheckbox"
                    (click)="ParentMenuCheckboxClicked('upsiCheckbox','upsiSubMenu', upsiMenu)">
                  <span style="font-weight: 600; font-size: 0.95rem; color: #495057;">Select All</span>
                </div>
              </div>

              <!-- Permissions Table -->
              <div style="max-height: 400px; overflow-y: auto;">
                <table class="permissions-table">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Permission Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let menu of upsiMenu" id="{{menu._id}}"
                      (mouseenter)="mouseoverDisplay(menu,$event,'upsi',menu.MenuDisplayName)"
                      (mouseleave)="mouseleaveDisplay(menu,$event,'upsi',menu.MenuDisplayName)">
                      <td>
                        <input type="checkbox" class="inputCheckbox" id="{{menu.MenuDisplayName}}"
                          (click)="checkboxClicked(menu,$event,menu.MenuDisplayName,'upsiCheckbox',upsiMenu)">
                      </td>
                      <td>
                        <span class="permission-name">{{menu.MenuDisplayName}}</span>
                      </td>
                      <td>
                        <div class="permission-icons-container" (mousedown)="$event.stopPropagation()">
                          <i class="rolemaster-icons rolemaster-icon-display fa"
                            [ngClass]="{'fa-eye' : child.IconName == 'view','fa-pencil' : child.IconName == 'edit','fa-plus-circle' : child.IconName == 'add','fa-trash-o' : child.IconName == 'delete' , 'fa-shield' : child.IconName == 'authorize' , 'fa-plus-square-o' : child.IconName == 'create' , 'fa-download' : child.IconName == 'download', 'fa-database' : child.IconName == 'database-backup' ,'fa-check-square-o' : child.IconName == 'review' , 'fa-caret-square-o-right' : child.IconName == 'execute', 'fa-file' : child.IconName == 'summaryReport','fa-file-pdf-o' : child.IconName == 'individualReport'}"
                            [class.icon-selected]="isIconSelected(child.Url)"
                            [class.icon-unselected]="!isIconSelected(child.Url)"
                            *ngFor="let child of menu.ChildResources" 
                            title="{{child.IconName}}" 
                            id="{{child.Url}}"
                            (mousedown)="$event.stopPropagation(); $event.preventDefault();"
                            (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view',menu.MenuDisplayName , child ,'upsiCheckbox',upsiMenu)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>



        </div>

        <!-- NCD Menu -->
        <div class="row" *ngIf="(isNCDConfig)">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown #myDrop="ngbDropdown" [autoClose]="'outside'" id="ncdMenu">

            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle (click)="LeftMenuClick('ncdMenu'); $event.stopPropagation()"
              data-toggle="dropdown" aria-expanded="false">

              NCD
            </a>

            <div ngbDropdownMenu placement="bottom-right" aria-labelledby="" id="ncdSubMenu"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              (click)="Submenu($event)" 
              (mousedown)="$event.stopPropagation()"
              role="menu" style="padding: 0; min-width: 600px;">

              <!-- Select All Header -->
              <div style="padding: 1rem 1.25rem; background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" class="inputCheckbox" id="ncdCheckbox"
                    (click)="ParentMenuCheckboxClicked('ncdCheckbox','ncdSubMenu', ncdMenu)">
                  <span style="font-weight: 600; font-size: 0.95rem; color: #495057;">Select All</span>
                </div>
              </div>

              <!-- Permissions Table -->
              <div style="max-height: 400px; overflow-y: auto;">
                <table class="permissions-table">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Permission Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let menu of ncdMenu" id="{{menu._id}}"
                      (mouseenter)="mouseoverDisplay(menu,$event,'ncd',menu.MenuDisplayName)"
                      (mouseleave)="mouseleaveDisplay(menu,$event,'ncd',menu.MenuDisplayName)">
                      <td>
                        <input type="checkbox" class="inputCheckbox" id="{{menu.MenuDisplayName}}"
                          (click)="checkboxClicked(menu,$event,menu.MenuDisplayName,'ncdCheckbox',ncdMenu)">
                      </td>
                      <td>
                        <span class="permission-name">{{menu.MenuDisplayName}}</span>
                      </td>
                      <td>
                        <div class="permission-icons-container" (mousedown)="$event.stopPropagation()">
                          <i class="rolemaster-icons rolemaster-icon-display fa"
                            [ngClass]="{'fa-eye' : child.IconName == 'view','fa-pencil' : child.IconName == 'edit','fa-plus-circle' : child.IconName == 'add','fa-trash-o' : child.IconName == 'delete' , 'fa-shield' : child.IconName == 'authorize' , 'fa-plus-square-o' : child.IconName == 'create' , 'fa-download' : child.IconName == 'download', 'fa-database' : child.IconName == 'database-backup' ,'fa-check-square-o' : child.IconName == 'review' , 'fa-caret-square-o-right' : child.IconName == 'execute', 'fa-file' : child.IconName == 'summaryReport','fa-file-pdf-o' : child.IconName == 'individualReport'}"
                            [class.icon-selected]="isIconSelected(child.Url)"
                            [class.icon-unselected]="!isIconSelected(child.Url)"
                            *ngFor="let child of menu.ChildResources" 
                            title="{{child.IconName}}" 
                            id="{{child.Url}}"
                            (mousedown)="$event.stopPropagation(); $event.preventDefault();"
                            (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view',menu.MenuDisplayName , child ,'ncdCheckbox',ncdMenu)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>



        </div>

        <!-- DO Not ALter ANy Dom Structure -->
        <!-- Admin menu -->

        <div class="row">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown [autoClose]="'outside'" id="adminMenu">
            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle (click)="LeftMenuClick('adminMenu'); $event.stopPropagation()"
              data-toggle="dropdown" aria-expanded="false">Admin</a>

            <div ngbDropdownMenu placement="bottom-right"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              id="adminSubMenu" aria-labelledby="" 
              (click)="Submenu($event)"
              (mousedown)="$event.stopPropagation()"
              role="menu" style="padding: 0; min-width: 600px;">

              <!-- Select All Header -->
              <div style="padding: 1rem 1.25rem; background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" class="inputCheckbox" id="adminCheckbox"
                    (click)="ParentMenuCheckboxClicked('adminCheckbox','adminSubMenu', adminMenu)">
                  <span style="font-weight: 600; font-size: 0.95rem; color: #495057;">Select All</span>
                </div>
              </div>

              <!-- Permissions Table -->
              <div style="max-height: 400px; overflow-y: auto;">
                <table class="permissions-table">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Permission Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let menu of adminMenu"
                      (mouseenter)="mouseoverDisplay(menu,$event,'Admin')"
                      (mouseleave)="mouseleaveDisplay(menu,$event,'Admin')">
                      <td>
                        <input type="checkbox" class="inputCheckbox" id="{{menu.DisplayName}}"
                          (click)="checkboxClicked(menu,$event,menu.DisplayName,'adminCheckbox',adminMenu)">
                      </td>
                      <td>
                        <span class="permission-name">{{menu.DisplayName}}</span>
                      </td>
                      <td>
                        <div class="permission-icons-container" (mousedown)="$event.stopPropagation()">
                          <i class="rolemaster-icons rolemaster-icon-display fa"
                            [ngClass]="{'fa-eye' : menu.IconName == 'view','fa-pencil' : menu.IconName == 'edit','fa-plus-circle' : menu.IconName == 'add','fa-trash-o' : menu.IconName == 'delete' , 'fa-shield' : menu.IconName == 'authorize' , 'fa-plus-square-o' : menu.IconName == 'create', 'fa-download' : menu.IconName == 'download', 'fa-database' : menu.IconName == 'database-backup' ,'fa-check-square-o' : menu.IconName == 'review' , 'fa-caret-square-o-right' : menu.IconName == 'execute', 'fa-file' : menu.IconName == 'summaryReport','fa-file-pdf-o' : menu.IconName == 'individualReport'}"
                            [class.icon-selected]="isIconSelected(menu.Url)"
                            [class.icon-unselected]="!isIconSelected(menu.Url)"
                            title="{{menu.IconName}}" 
                            id="{{menu.Url}}"
                            (mousedown)="$event.stopPropagation(); $event.preventDefault();"
                            (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view',menu.DisplayName , menu,'adminCheckbox',adminMenu)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- DO Not ALter ANy Dom Structure -->
        <!-- dashboard Menu -->
        <div class="row" *ngIf="(isGovevaConfig || isAllConfig || isPSSConfig)">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown [autoClose]="'outside'" id="dashboardMenu">
            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle (click)="LeftMenuClick('dashboardMenu'); $event.stopPropagation()"
              data-toggle="dropdown" aria-expanded="false">Dashboard</a>

            <div ngbDropdownMenu placement="bottom-right"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              id="dashboardSubMenu" aria-labelledby="" 
              (click)="Submenu($event)"
              (mousedown)="$event.stopPropagation()"
              role="menu" style="padding: 0; min-width: 600px;">

              <!-- Select All Header -->
              <div style="padding: 1rem 1.25rem; background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" class="inputCheckbox" id="dashboardCheckbox"
                    (click)="ParentMenuCheckboxClicked('dashboardCheckbox','dashboardSubMenu', dashboardMenu)">
                  <span style="font-weight: 600; font-size: 0.95rem; color: #495057;">Select All</span>
                </div>
              </div>

              <!-- Permissions Table -->
              <div style="max-height: 400px; overflow-y: auto;">
                <table class="permissions-table">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Permission Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let menu of dashboardMenu"
                      (mouseenter)="mouseoverDisplay(menu,$event,'Dashboard')"
                      (mouseleave)="mouseleaveDisplay(menu,$event,'Dashboard')">
                      <td>
                        <input type="checkbox" class="inputCheckbox" id="{{menu.DisplayName}}"
                          (click)="checkboxClicked(menu,$event,menu.DisplayName,'dashboardCheckbox',dashboardMenu)">
                      </td>
                      <td>
                        <span class="permission-name">{{menu.DisplayName}}</span>
                      </td>
                      <td>
                        <div class="permission-icons-container" (mousedown)="$event.stopPropagation()">
                          <i class="rolemaster-icons rolemaster-icon-display fa"
                            [ngClass]="{'fa-eye' : menu.IconName == 'view','fa-pencil' : menu.IconName == 'edit','fa-plus-circle' : menu.IconName == 'add','fa-trash-o' : menu.IconName == 'delete' , 'fa-shield' : menu.IconName == 'authorize' , 'fa-plus-square-o' : menu.IconName == 'create', 'fa-download' : menu.IconName == 'download', 'fa-database' : menu.IconName == 'database-backup','fa-check-square-o' : menu.IconName == 'review' , 'fa-caret-square-o-right' : menu.IconName == 'execute', 'fa-file' : menu.IconName == 'summaryReport','fa-file-pdf-o' : menu.IconName == 'individualReport'}"
                            [class.icon-selected]="isIconSelected(menu.Url)"
                            [class.icon-unselected]="!isIconSelected(menu.Url)"
                            title="{{menu.IconName}}" 
                            id="{{menu.Url}}"
                            (mousedown)="$event.stopPropagation(); $event.preventDefault();"
                            (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view',menu.DisplayName , menu,'dashboardCheckbox',dashboardMenu)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>


        <!-- DO Not ALter ANy Dom Structure -->
        <!-- GEM Menu -->
        <div class="row" *ngIf="isGEMConfig">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown [autoClose]="'outside'" id="gemMenu">
            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle (click)="LeftMenuClick('gemMenu'); $event.stopPropagation()"
              data-toggle="dropdown" aria-expanded="false">DigiCompany Boards</a>

            <div ngbDropdownMenu placement="bottom-right"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              id="gemSubMenu" aria-labelledby="" 
              (click)="Submenu($event)"
              (mousedown)="$event.stopPropagation()"
              role="menu" style="padding: 0; min-width: 600px;">

              <!-- Select All Header -->
              <div style="padding: 1rem 1.25rem; background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" class="inputCheckbox" id="gemCheckbox"
                    (click)="ParentMenuCheckboxClicked('gemCheckbox','gemSubMenu', gemMenu)">
                  <span style="font-weight: 600; font-size: 0.95rem; color: #495057;">Select All</span>
                </div>
              </div>

              <!-- Permissions Table -->
              <div style="max-height: 400px; overflow-y: auto;">
                <table class="permissions-table">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Permission Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let menu of gemMenu"
                      (mouseenter)="mouseoverDisplay(menu,$event,'GEM')"
                      (mouseleave)="mouseleaveDisplay(menu,$event,'GEM')">
                      <td>
                        <input type="checkbox" class="inputCheckbox" id="{{menu.MenuDisplayName}}"
                          (click)="checkboxClicked(menu,$event,menu.MenuDisplayName,'gemCheckbox',gemMenu)">
                      </td>
                      <td>
                        <span class="permission-name">{{menu.MenuDisplayName}}</span>
                      </td>
                      <td>
                        <div class="permission-icons-container" (mousedown)="$event.stopPropagation()">
                          <i class="rolemaster-icons rolemaster-icon-display fa"
                            [ngClass]="{'fa-eye' : child.IconName == 'view','fa-pencil' : child.IconName == 'edit','fa-plus-circle' : child.IconName == 'add','fa-trash-o' : child.IconName == 'delete' , 'fa-shield' : child.IconName == 'authorize' , 'fa-plus-square-o' : child.IconName == 'create', 'fa-download' : child.IconName == 'download', 'fa-database' : child.IconName == 'database-backup','fa-check-square-o' : child.IconName == 'review' , 'fa-caret-square-o-right' : child.IconName == 'execute', 'fa-file' : child.IconName == 'summaryReport','fa-file-pdf-o' : child.IconName == 'individualReport'}"
                            [class.icon-selected]="isIconSelected(child.Url)"
                            [class.icon-unselected]="!isIconSelected(child.Url)"
                            *ngFor="let child of menu.ChildResources" 
                            title="{{child.IconName}}" 
                            id="{{child.Url}}"
                            (mousedown)="$event.stopPropagation(); $event.preventDefault();"
                            (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view',menu.MenuDisplayName , child,'gemCheckbox',gemMenu)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- DO Not ALter ANy Dom Structure -->
        <!-- Law And Regulation Menu -->
        <div class="row"
          *ngIf="(isPSSConfig || isAllConfig) && (!isMeetingMakerWithoutAgenda && !isMeetingMakerWithAgenda) && isLawsConfig">
          <div class="dropdown col-md-12 rolemaster-parentmenu" ngbDropdown [autoClose]="'outside'" id="lawAndRegulationMenu">
            <a href="javascript: void(0);" style="text-align: left;"
              class="btn rolemaster-menu dropdown-toggle col-md-5 role-name" ngbDropdownToggle
              (click)="LeftMenuClick('lawAndRegulationMenu'); $event.stopPropagation()" data-toggle="dropdown" aria-expanded="false">Laws &
              Regulations</a>

            <div ngbDropdownMenu placement="bottom-right"
              class="rolemaster-menu dropdown-menu-right col-md-7 dropdown-top-align-menu rolemaster-viewall position-change"
              id="lawAndRegulationSubMenu" aria-labelledby="" 
              (click)="Submenu($event)"
              (mousedown)="$event.stopPropagation()"
              role="menu" style="padding: 0; min-width: 600px;">

              <!-- Select All Header -->
              <div style="padding: 1rem 1.25rem; background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <input type="checkbox" class="inputCheckbox" id="lawAndRegulationCheckbox"
                    (click)="ParentMenuCheckboxClicked('lawAndRegulationCheckbox','lawAndRegulationSubMenu', lawAndRegulationMenu)">
                  <span style="font-weight: 600; font-size: 0.95rem; color: #495057;">Select All</span>
                </div>
              </div>

              <!-- Permissions Table -->
              <div style="max-height: 400px; overflow-y: auto;">
                <table class="permissions-table">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Permission Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let menu of lawAndRegulationMenu"
                      (mouseenter)="mouseoverDisplay(menu,$event,'lawAndRegulation')"
                      (mouseleave)="mouseleaveDisplay(menu,$event,'lawAndRegulation')">
                      <td>
                        <input type="checkbox" class="inputCheckbox" id="{{menu.MenuDisplayName}}"
                          (click)="checkboxClicked(menu,$event,menu.MenuDisplayName,'lawAndRegulationCheckbox',lawAndRegulationMenu)">
                      </td>
                      <td>
                        <span class="permission-name">{{menu.MenuDisplayName}}</span>
                      </td>
                      <td>
                        <div class="permission-icons-container" (mousedown)="$event.stopPropagation()">
                          <i class="rolemaster-icons rolemaster-icon-display fa"
                            [ngClass]="{'fa-eye' : child.IconName == 'view','fa-pencil' : child.IconName == 'edit','fa-plus-circle' : child.IconName == 'add','fa-trash-o' : child.IconName == 'delete' , 'fa-shield' : child.IconName == 'authorize' , 'fa-plus-square-o' : child.IconName == 'create', 'fa-database' : child.IconName == 'database-backup' ,'fa-check-square-o' : child.IconName == 'review' , 'fa-caret-square-o-right' : child.IconName == 'execute', 'fa-file' : child.IconName == 'summaryReport','fa-file-pdf-o' : child.IconName == 'individualReport'}"
                            [class.icon-selected]="isIconSelected(child.Url)"
                            [class.icon-unselected]="!isIconSelected(child.Url)"
                            *ngFor="let child of menu.ChildResources" 
                            title="{{child.IconName}}" 
                            id="{{child.Url}}"
                            (mousedown)="$event.stopPropagation(); $event.preventDefault();"
                            (click)="$event.stopPropagation(); $event.preventDefault(); iconClicked($event,menu,'view',menu.MenuDisplayName , child,'lawAndRegulationCheckbox',lawAndRegulationMenu)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>


      <!-- role activities validation Message -->
      <div class="row">
        <div class="col-md-12 text-left" *ngIf="isfinalRoleListEmpty">
          <div class="alert alert-warning mb-0" style="background: #fff3cd; border: 1px solid #ffc107; border-radius: 8px; padding: 0.75rem 1rem;">
            <i class="fa fa-exclamation-triangle mr-2"></i>
            <strong>Please select Role activities from the list</strong>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 text-left mb-3">
            <strong class="pl-1" style="font-size: 1rem; color: #495057;">
              <i class="fa fa-check-circle mr-2" style="color: #4A90E2;"></i>Added Roles
            </strong>
          </div>
          <div class="col-md-12">
            <div class="d-flex flex-wrap" *ngIf="addedRoles.length > 0">
              <div class="btn-xs" *ngFor="let role of addedRoles;let i=index">
                {{getDisplayName(role.MenuDisplayName)}}
                <i class="fa fa-times fa-fw" (click)="removeAddedRoleList(i,role)" (keydown.enter)="removeAddedRoleList(i,role)" (keydown.space)="removeAddedRoleList(i,role); $event.preventDefault()" tabindex="0" role="button"></i>
              </div>
            </div>
            <p class="text-muted small mt-2" *ngIf="addedRoles.length === 0">No roles added yet</p>
          </div>
        </div>
      </div>
    </div>
  </form>



</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default btn-sm footer-button cancel-button"
    (click)="CancelModal()">
    <i class="fa fa-times mr-2"></i>Cancel
  </button>
  <button type="button" class="btn btn-primary btn-sm footer-button"
    [disabled]="(!addRoleForm.valid) || isfinalRoleListEmpty" (click)="SubmitRole()">
    <i class="fa fa-save mr-2"></i>Save
  </button>
</div>